const getNumberOfLines = () => (window.customizationSettings && window.customizationSettings.lines) || 0;

let state = null;
let customizationElements = null;
let currentSide = "front";
let currentVariantPrice = 0;
/** Unsubscriber for variantChange - must be module-level so we unsubscribe before re-subscribing on re-init */
let variantChangeUnsubscriber = null;
let customizerIsOpen = false;
let imageMap = {};

function createEmptyLines() {
  return Array.from({ length: getNumberOfLines() }, () => ({ text: "" }));
}

function createInitialState() {
  return {
    front: {
      selectedImage: "",
      selectedFont: null,
      lines: createEmptyLines(),
      type: "text",
    },
    back: {
      selectedImage: "",
      selectedFont: null,
      lines: createEmptyLines(),
      type: "text",
    },
  };
}

const baseState = createInitialState();

function resetState(stateObj, side) {
  switch (side) {
    case "front":
      stateObj.front = {
        selectedImage: "",
        selectedFont: null,
        lines: createEmptyLines(),
        type: "text",
      };
      break;
    case "back":
      stateObj.back = {
        selectedImage: "",
        selectedFont: null,
        lines: createEmptyLines(),
        type: "text",
      };
      break;
    default:
      stateObj.front = {
        selectedImage: "",
        selectedFont: null,
        lines: createEmptyLines(),
        type: "text",
      };
      stateObj.back = {
        selectedImage: "",
        selectedFont: null,
        lines: createEmptyLines(),
        type: "text",
      };
  }
}

function resetUIOnLoad(elements) {
  const sideTextSpan = document.querySelector(".current-side-text");
  if (sideTextSpan) {
    sideTextSpan.textContent = "Customizing front side";
  }
  updateCustomizationPrice();
  elements.sideRadios.forEach((radio) => {
    radio.checked = radio.value === "front";
  });

  const initialType = state?.front?.type || "text";
  elements.typeRadios.forEach((radio) => {
    radio.checked = radio.value === initialType;
  });

  elements.lineInputs.forEach((input) => {
    input.value = "";
  });

  elements.fontRadios.forEach((radio) => {
    radio.checked = false;
  });

  document.querySelectorAll('input[name="properties[Front Image]"]').forEach((radio) => {
    radio.checked = radio.value === "";
  });

  document.querySelectorAll('input[name="properties[Back Image]"]').forEach((radio) => {
    radio.checked = radio.value === "";
  });

  const clearBtn = document.querySelector('.customization-clear-btn');
  if (clearBtn) clearBtn.style.display = 'none';

  if (elements.frontImageDiv) {
    elements.frontImageDiv.style.display = initialType === "image" ? "block" : "none";
  }
  if (elements.backImageDiv) {
    elements.backImageDiv.style.display = "none";
  }

  if (elements.textPreview) {
    const previewLines = elements.textPreview.querySelectorAll("[data-line-preview]");
    previewLines.forEach((line) => {
      line.textContent = "";
      line.hidden = true;
    });
  }

  if (elements.imagePreview) {
    elements.imagePreview.src = "";
    elements.imagePreview.style.display = "none";
  }

  if (elements.customizationOptions) {
    elements.customizationOptions.style.display = "none";
  }

  const fontSelection = elements.customizer.querySelector(".font-selection");
  if (fontSelection) {
    fontSelection.style.display = initialType === "text" ? "block" : "none";
  }

  elements.lineInputs.forEach((input) => {
    const wrapper = input.closest(".text-line-input-wrapper");
    if (wrapper) wrapper.style.display = initialType === "text" ? "block" : "none";
  });

  requestAnimationFrame(() => {
    elements.lineInputs.forEach((input) => {
      input.value = "";
    });

    elements.sideRadios.forEach((radio) => {
      radio.checked = radio.value === "front";
    });

    elements.typeRadios.forEach((radio) => {
      radio.checked = radio.value === initialType;
    });

    elements.fontRadios.forEach((radio) => {
      radio.checked = false;
    });

    document.querySelectorAll('input[name="properties[Front Image]"]').forEach((radio) => {
      radio.checked = radio.value === "";
    });

    document.querySelectorAll('input[name="properties[Back Image]"]').forEach((radio) => {
      radio.checked = radio.value === "";
    });
  });

  // Extra aggressive reset for fonts (they might be in Swiper, which can restore state)
  setTimeout(() => {
    elements.fontRadios.forEach((radio) => {
      radio.checked = false;
      radio.removeAttribute("checked");
    });
  }, 100);
}

function updateCustomizationPrice() {
  const priceAddons = document.querySelectorAll(".customization-price-addon");
  if (!priceAddons.length) return;

  priceAddons.forEach(addon => {
    const form = addon.closest('form');
    if (!form) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    let unitPrice = 0;

    // Text engraving only counts when font is also selected (customization complete)
    const frontHasText = state.front.lines.some(line => line.text.trim() !== "");
    const frontHasImage = !!state.front.selectedImage;

    if (frontHasText && state.front.selectedFont) {
      unitPrice += parseFloat(window.customizationSettings?.text_product?.price || 0) / 100;
    }
    if (frontHasImage) {
      unitPrice += parseFloat(window.customizationSettings?.image_product?.price || 0) / 100;
    }

    const backHasText = state.back.lines.some(line => line.text.trim() !== "");
    const backHasImage = !!state.back.selectedImage;

    if (backHasText && state.back.selectedFont) {
      unitPrice += parseFloat(window.customizationSettings?.text_product?.price || 0) / 100;
    }
    if (backHasImage) {
      unitPrice += parseFloat(window.customizationSettings?.image_product?.price || 0) / 100;
    }

    const engravingPrice = unitPrice;
    const itemPrice = currentVariantPrice;
    const totalPrice = (itemPrice + engravingPrice) * quantity;

    if (engravingPrice > 0) {
      addon.textContent = ` ($${totalPrice.toFixed(2)})`;
      addon.style.display = 'inline';
    } else {
      addon.textContent = '';
      addon.style.display = 'none';
    }
  });

  const frontHasText = state.front.lines.some(line => line.text.trim() !== "");
  const frontHasImage = state.front.selectedImage;
  const backHasText = state.back.lines.some(line => line.text.trim() !== "");
  const backHasImage = state.back.selectedImage;
  updateCheckmarks(frontHasText, frontHasImage, backHasText, backHasImage);
}

function updateCheckmarks(frontHasText, frontHasImage, backHasText, backHasImage) {
  const frontSideCheck = document.querySelector('[data-side-check="front"]');
  const backSideCheck = document.querySelector('[data-side-check="back"]');

  if (frontSideCheck) {
    const shouldShow = frontHasText || frontHasImage;
    frontSideCheck.style.display = shouldShow ? 'inline-flex' : 'none';
    frontSideCheck.style.color = currentSide === "front" ? 'white' : 'var(--color-dark-gray)';
  }
  if (backSideCheck) {
    const shouldShow = backHasText || backHasImage;
    backSideCheck.style.display = shouldShow ? 'inline-flex' : 'none';
    backSideCheck.style.color = currentSide === "back" ? 'white' : 'var(--color-dark-gray)';
  }

  const textTypeCheck = document.querySelector('[data-type-check="text"]');
  const imageTypeCheck = document.querySelector('[data-type-check="image"]');
  
  const currentSideHasText = currentSide === "front" ? frontHasText : backHasText;
  const currentSideHasImage = currentSide === "front" ? frontHasImage : backHasImage;
  
  if (textTypeCheck) {
    textTypeCheck.style.display = currentSideHasText ? 'inline-flex' : 'none';
    textTypeCheck.style.color = state[currentSide].type === "text" ? 'white' : 'var(--color-dark-gray)';
  }
  if (imageTypeCheck) {
    imageTypeCheck.style.display = currentSideHasImage ? 'inline-flex' : 'none';
    imageTypeCheck.style.color = state[currentSide].type === "image" ? 'white' : 'var(--color-dark-gray)';
  }
}

let _successMessageTimers = [];
function showSuccessMessage() {
  const successMessage = document.querySelector(".customization-success-message");
  if (!successMessage) return;

  _successMessageTimers.forEach(clearTimeout);
  _successMessageTimers = [];

  successMessage.style.transition = "none";
  successMessage.style.opacity = "0";
  successMessage.style.display = "flex";

  _successMessageTimers.push(setTimeout(() => {
    successMessage.style.transition = "opacity 0.5s ease";
    successMessage.style.opacity = "1";
    _successMessageTimers.push(setTimeout(() => {
      successMessage.style.opacity = "0";
      _successMessageTimers.push(setTimeout(() => {
        successMessage.style.display = "none";
      }, 500));
    }, 7000));
  }, 50));
}

function hideSuccessMessage() {
  _successMessageTimers.forEach(clearTimeout);
  _successMessageTimers = [];
  const successMessage = document.querySelector(".customization-success-message");
  if (successMessage) {
    successMessage.style.transition = "none";
    successMessage.style.opacity = "0";
    successMessage.style.display = "none";
  }
}

function enableCustomizationOptions() {
  const customizer = document.querySelector(".product_customization");
  if (customizer) {
    customizer.style.opacity = "1";
    customizer.style.pointerEvents = "auto";
    customizer.style.filter = "none";
  }
}

function disableCustomizationOptions() {
  const customizer = document.querySelector(".product_customization");
  if (customizer) {
    customizer.style.opacity = "0.5";
    customizer.style.pointerEvents = "none";
    customizer.style.filter = "grayscale(100%)";
  }
}

function hardReset(elements) {
  resetState(state);
  resetUIOnLoad(elements);
  currentSide = "front";
}

let isInitializing = false;
function initializeCustomizer(force = false) {
  if (!window.customizationSettings) return;

  if (typeof Swiper === 'undefined') {
    if (!isInitializing || force) {
      isInitializing = true;
      setTimeout(() => {
        isInitializing = false;
        initializeCustomizer(force);
      }, 100);
    }
    return;
  }
  
  if (window.customizerInitialized && !force) return;
  window.customizerInitialized = true;

  state = createInitialState();
  currentSide = "front";

  // Sync initial type from checked radio (handles cases where text=false and image=true)
  const checkedTypeRadio = document.querySelector('input[name="customization_type"]:checked');
  if (checkedTypeRadio) {
    state.front.type = checkedTypeRadio.value;
    state.back.type = checkedTypeRadio.value;
  }

  let variantChangeUnsubscriber = null;

  const customizer = document.querySelector(".product_customization");
  if (!customizer) return;

  const currentVariantId = document.querySelector('input[name="id"]')?.value;
  if (currentVariantId) {
    const currentVariant = window.productVariants?.find(v => v.id == currentVariantId);
    currentVariantPrice = currentVariant ? currentVariant.price / 100 : 0;
    if (currentVariant && !currentVariant.available) {
      disableCustomizationOptions();
    } else {
      enableCustomizationOptions();
    }
  }

  const customizationOptions = customizer.querySelector(
    ".customization-options",
  );
  

  const textPreview = customizer.querySelector(
    ".product-customization__text-preview",
  );
  const imagePreview = customizer.querySelector(
    ".product-customization__image-preview",
  );
  const lineInputs = customizer.querySelectorAll(
    'input[name^="properties[Line"]',
  );
  const sideRadios = customizer.querySelectorAll(
    'input[name="customization_side"]',
  );
  const typeRadios = customizer.querySelectorAll(
    'input[name="customization_type"]',
  );
  const fontRadios = customizer.querySelectorAll(
    'input[name="properties[Font]"]',
  );
  const frontImageRadios = customizer.querySelectorAll(
    'input[name="properties[Front Image]"]',
  );
  const backImageRadios = customizer.querySelectorAll(
    'input[name="properties[Back Image]"]',
  );
  const frontImageDiv = customizer.querySelector(".front-image-selection");
  const backImageDiv = customizer.querySelector(".back-image-selection");

  imageMap = {};
  if (frontImageDiv) {
    frontImageDiv.querySelectorAll("img").forEach((img) => {
      imageMap[img.alt.replace(/\.[^/.]+$/, "")] = img.src;
    });
  }

  const fontSwiper = new Swiper(".customization-font-swiper", {
    slidesPerView: 4,
    spaceBetween: -40,
    grid: {
      rows: 2,
      fill: "row",
    },
    navigation: {
      nextEl: ".customization-font-swiper .swiper-button-next",
      prevEl: ".customization-font-swiper .swiper-button-prev",
    },
    breakpoints: {
      50: {
        slidesPerView: 2,
        spaceBetween: -20,
        grid: {
          rows: 3,
          fill: "row",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: -30,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: -40,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
    },
  });

  const frontImageSwiper = new Swiper(".customization-front-image-swiper", {
    slidesPerView: 4,
    spaceBetween: -40,
    grid: {
      rows: 2,
      fill: "row",
    },
    navigation: {
      nextEl: ".customization-front-image-swiper .swiper-button-next",
      prevEl: ".customization-front-image-swiper .swiper-button-prev",
    },
    breakpoints: {
      50: {
        slidesPerView: 2,
        spaceBetween: -20,
        grid: {
          rows: 3,
          fill: "row",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: -30,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: -40,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
    },
  });

  const backImageSwiper = new Swiper(".customization-back-image-swiper", {
    slidesPerView: 4,
    spaceBetween: -40,
    grid: {
      rows: 2,
      fill: "row",
    },
    navigation: {
      nextEl: ".customization-back-image-swiper .swiper-button-next",
      prevEl: ".customization-back-image-swiper .swiper-button-prev",
    },
    breakpoints: {
      50: {
        slidesPerView: 2,
        spaceBetween: -20,
        grid: {
          rows: 3,
          fill: "row",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: -30,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: -40,
        grid: {
          rows: 2,
          fill: "row",
        },
      },
    },
  });

  sideRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      // Snapshot current input values into state BEFORE changing currentSide.
      // On mobile, keyboard dismissal can fire stray input events after currentSide
      // has already been updated, which would corrupt the wrong side's state.
      const previousSide = currentSide;
      lineInputs.forEach((input, index) => {
        state[previousSide].lines[index].text = input.value;
      });
      currentSide = radio.value;
      const sideTextSpan = document.querySelector(".current-side-text");
      if (sideTextSpan) {
        sideTextSpan.textContent = `Customizing ${currentSide.toLowerCase()} side`;
      }
      const clearBtn = document.querySelector('.customization-clear-btn');
      if (clearBtn) {
        clearBtn.setAttribute('data-clear-side', currentSide);
      }
      updateUIForSide(
        state,
        currentSide,
        textPreview,
        imagePreview,
        lineInputs,
        fontRadios,
        frontImageRadios,
        backImageRadios,
        frontImageDiv,
        backImageDiv,
        sideRadios,
        typeRadios,
        imageMap,
      );
      updateCustomizationPrice();
    });
  });

  const clearBtn = document.querySelector('.customization-clear-btn');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      const sideToClear = clearBtn.getAttribute('data-clear-side');
      if (sideToClear) {
        hideSuccessMessage();
        hideFontError();
        
        if (state[sideToClear].type === "text") {
          state[sideToClear].selectedFont = null;
          state[sideToClear].lines.forEach((line) => (line.text = ""));
        } else if (state[sideToClear].type === "image") {
          state[sideToClear].selectedImage = "";
        }

        updateUIForSide(
          state,
          currentSide,
          textPreview,
          imagePreview,
          lineInputs,
          fontRadios,
          frontImageRadios,
          backImageRadios,
          frontImageDiv,
          backImageDiv,
          sideRadios,
          typeRadios,
          imageMap,
        );
        updateCustomizationPrice();
        
        // Explicitly update checkmarks after clearing
        const frontHasText = state.front.lines.some(line => line.text.trim() !== "");
        const frontHasImage = !!state.front.selectedImage;
        const backHasText = state.back.lines.some(line => line.text.trim() !== "");
        const backHasImage = !!state.back.selectedImage;
        updateCheckmarks(frontHasText, frontHasImage, backHasText, backHasImage);
      }
    });
  }

  typeRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        state[currentSide].type = radio.value;
        hideSuccessMessage();
        // Clear the other type's data
        if (radio.value === "text") {
          state[currentSide].selectedImage = "";
          updateImagePreview(state, currentSide, imagePreview, imageMap);
        } else {
          state[currentSide].lines.forEach((line) => (line.text = ""));
          state[currentSide].selectedFont = null;
          hideFontError();
          updateTextPreview(state, currentSide, textPreview);
        }
        updateCustomizationPrice();
        updateUIForSide(
          state,
          currentSide,
          textPreview,
          imagePreview,
          lineInputs,
          fontRadios,
          frontImageRadios,
          backImageRadios,
          frontImageDiv,
          backImageDiv,
          sideRadios,
          typeRadios,
          imageMap,
        );
      }
    });
  });

  fontRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        state[currentSide].selectedFont = radio.value;
        hideFontError();
        updateTextPreview(state, currentSide, textPreview);
        const clearBtn = document.querySelector('.customization-clear-btn');
        if (clearBtn) {
          const hasText = state[currentSide].lines.some(l => l.text.trim() !== "");
          const hasImage = !!state[currentSide].selectedImage;
          clearBtn.style.display = (hasText || hasImage || !!state[currentSide].selectedFont) ? 'inline-block' : 'none';
        }
        // Only show success if there's text content
        const hasText = state[currentSide].lines.some(line => line.text.trim() !== "");
        if (hasText) {
          showSuccessMessage();
        }
        updateCustomizationPrice();
      }
    });
  });

  lineInputs.forEach((input, index) => {
    input.addEventListener("input", () => {
      state[currentSide].lines[index].text = input.value;
      // Clear image when text is entered
      if (input.value.trim()) {
        state[currentSide].selectedImage = "";
        state[currentSide].type = "text";
        // Update type radio
        typeRadios.forEach((r) => (r.checked = r.value === "text"));
        updateImagePreview(state, currentSide, imagePreview, imageMap);
      }
      updateTextPreview(state, currentSide, textPreview);
      
      updateCustomizationPrice();
      
      updateUIForSide(
        state,
        currentSide,
        textPreview,
        imagePreview,
        lineInputs,
        fontRadios,
        frontImageRadios,
        backImageRadios,
        frontImageDiv,
        backImageDiv,
        sideRadios,
        typeRadios,
        imageMap,
      );
    });
  });

  customizer.addEventListener("change", (e) => {
    const radio = e.target;
    if (radio.name === "properties[Front Image]" && radio.checked) {
      state.front.selectedImage = radio.value.replace(/\.[^/.]+$/, "");
      state.front.lines.forEach((line) => (line.text = ""));
      state.front.type = "image";
      hideFontError();
      typeRadios.forEach((r) => (r.checked = r.value === "image"));
      updateTextPreview(state, "front", textPreview);
      updateImagePreview(state, "front", imagePreview, imageMap);
      showSuccessMessage();
      updateCustomizationPrice();
      const currentFrontRadios = customizer.querySelectorAll('input[name="properties[Front Image]"]');
      const currentBackRadios = customizer.querySelectorAll('input[name="properties[Back Image]"]');
      updateUIForSide(
        state, "front", textPreview, imagePreview, lineInputs, fontRadios,
        currentFrontRadios, currentBackRadios, frontImageDiv, backImageDiv, sideRadios, typeRadios, imageMap,
      );
    } else if (radio.name === "properties[Back Image]" && radio.checked) {
      state.back.selectedImage = radio.value.replace(/\.[^/.]+$/, "");
      state.back.lines.forEach((line) => (line.text = ""));
      state.back.type = "image";
      hideFontError();
      typeRadios.forEach((r) => (r.checked = r.value === "image"));
      updateTextPreview(state, "back", textPreview);
      updateImagePreview(state, "back", imagePreview, imageMap);
      showSuccessMessage();
      updateCustomizationPrice();
      const currentFrontRadios = customizer.querySelectorAll('input[name="properties[Front Image]"]');
      const currentBackRadios = customizer.querySelectorAll('input[name="properties[Back Image]"]');
      updateUIForSide(
        state, "back", textPreview, imagePreview, lineInputs, fontRadios,
        currentFrontRadios, currentBackRadios, frontImageDiv, backImageDiv, sideRadios, typeRadios, imageMap,
      );
    }
  });

  const productForm = document.querySelector("product-form");
  if (productForm) {
    if (productForm.dataset.customizationInitialized && !force) return;
    productForm.dataset.customizationInitialized = "true";
    
    let isSubmitting = false;

    productForm.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isSubmitting) return;
      if (hasAnyCustomization(state)) {
        const fontError = validateFontSelection(state);
        if (fontError) { showFontError(fontError); return; }
        hideFontError();
        showConfirmModal(() => {
          isSubmitting = true;
          addToCartWithCustomization(state).finally(() => {
            isSubmitting = false;
          });
        });
      } else {
        isSubmitting = true;
        addToCartWithCustomization(state).finally(() => {
          isSubmitting = false;
        });
      }
    }, { capture: true });
    
    // Setup Buy It Now / dynamic checkout interceptor
    setupBuyItNowInterceptor(productForm, state, force);

    if (variantChangeUnsubscriber) {
      variantChangeUnsubscriber();
      variantChangeUnsubscriber = null;
    }

    variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        const variant = event?.data?.variant;
        if (!variant) return;

        currentVariantPrice = variant.price / 100;

        if (variant.available) {
          enableCustomizationOptions();
        } else {
          disableCustomizationOptions();
        }

        const sidesPreview = variant.metafields?.image_preview;

        const sidesPreviewDiv = document.querySelector('.sides-preview');
        const img = document.getElementById('sides-preview-image');

        if (sidesPreviewDiv && img) {
          if (sidesPreview) {
            img.src = `${sidesPreview}&t=${Date.now()}`;
            sidesPreviewDiv.style.display = 'flex';
          } else {
            sidesPreviewDiv.style.display = 'none';
          }
        }

        var personalizationUrl = null;
        if (window.productVariants && variant && variant.id) {
          var pv = window.productVariants.find(function (v) { return v.id === variant.id; });
          if (pv && pv.product_image_personalization_url) personalizationUrl = pv.product_image_personalization_url;
        }
        var personalizationWrap = document.getElementById('variant-personalization-media');
        var personalizationImg = document.getElementById('variant-personalization-media-image');
        if (personalizationWrap && personalizationImg) {
          if (personalizationUrl) {
            personalizationImg.src = personalizationUrl;
            personalizationWrap.style.display = 'flex';
          } else {
            personalizationWrap.style.display = 'none';
          }
        }

        // Close customization section on variant change
        customizerIsOpen = false;
        const custOptEl = document.querySelector('.customization-options');
        if (custOptEl) custOptEl.style.display = 'none';
      }
    );

    var initialVariantIdInput = productForm && productForm.querySelector('input[name="id"]');
    if (initialVariantIdInput && window.productVariants && window.productVariants.length) {
      var initialVariantId = parseInt(initialVariantIdInput.value, 10);
      var initialPv = window.productVariants.find(function (v) { return v.id === initialVariantId; });
      var personalizationWrapInit = document.getElementById('variant-personalization-media');
      var personalizationImgInit = document.getElementById('variant-personalization-media-image');
      if (personalizationWrapInit && personalizationImgInit && initialPv && initialPv.product_image_personalization_url) {
        personalizationImgInit.src = initialPv.product_image_personalization_url;
        personalizationWrapInit.style.display = 'flex';
      }
    }

    const sidesPreviewImg = document.getElementById('sides-preview-image');
    const sidesPreviewDiv = document.querySelector('.sides-preview');

    if (sidesPreviewImg && sidesPreviewDiv && !sidesPreviewImg.src) {
      sidesPreviewDiv.style.display = 'none';
    }

    // Add listeners to all quantity inputs
    document.querySelectorAll('input[name="quantity"]').forEach(input => {
      input.addEventListener("input", updateCustomizationPrice);
      input.addEventListener("change", updateCustomizationPrice);
    });
    // Add observers to all quantity-input components
    document.querySelectorAll("quantity-input").forEach(component => {
      const observer = new MutationObserver(updateCustomizationPrice);
      observer.observe(component, { childList: true, subtree: true, attributes: true });
    });
  }

  customizationElements = {
    customizer,
    sideRadios,
    typeRadios,
    lineInputs,
    fontRadios,
    frontImageRadios,
    backImageRadios,
    frontImageDiv,
    backImageDiv,
    textPreview,
    imagePreview,
    customizationOptions,
  };

  const clearBtnInit = document.querySelector('.customization-clear-btn');
  if (clearBtnInit) {
    clearBtnInit.setAttribute('data-clear-side', currentSide);
  }

  resetUIOnLoad(customizationElements);
}

function updateUIForSide(
  state,
  side,
  textPreview,
  imagePreview,
  lineInputs,
  fontRadios,
  frontImageRadios,
  backImageRadios,
  frontImageDiv,
  backImageDiv,
  sideRadios,
  typeRadios,
  imageMap,
) {
  // Update side radios
  sideRadios.forEach((radio) => {
    radio.checked = radio.value === side;
  });

  // Update type radios
  typeRadios.forEach((radio) => {
    radio.checked = radio.value === state[side].type;
  });

  lineInputs.forEach((input, index) => {
    input.value = state[side].lines[index]?.text || "";
  });

  fontRadios.forEach((radio) => {
    radio.checked = radio.value === state[side].selectedFont;
  });

  // Show/hide options based on type
  const isText = state[side].type === "text";
  const isImage = state[side].type === "image";

  // Show text options if text type
  lineInputs.forEach((input) => {
    const wrapper = input.closest(".text-line-input-wrapper");
    if (wrapper) wrapper.style.display = isText ? "block" : "none";
  });
  const fontSelection = document.querySelector(".font-selection");
  if (fontSelection) fontSelection.style.display = isText ? "block" : "none";

  // Update font title based on side
  const fontTitle = document.getElementById("font-title");
  if (fontTitle) {
    fontTitle.textContent = `Choose ${side.charAt(0).toUpperCase() + side.slice(1)} Text`;
  }

  // Show image selection if image type and current side
  if (frontImageDiv) {
    frontImageDiv.style.display =
      side === "front" && isImage ? "block" : "none";
  }
  if (backImageDiv) {
    backImageDiv.style.display = side === "back" && isImage ? "block" : "none";
  }

  frontImageRadios.forEach((radio) => {
    radio.checked = radio.value.replace(/\.[^/.]+$/, "") === state.front.selectedImage;
  });
  backImageRadios.forEach((radio) => {
    radio.checked = radio.value.replace(/\.[^/.]+$/, "") === state.back.selectedImage;
  });

  // Show text preview if text type
  if (textPreview) textPreview.style.display = isText ? "flex" : "none";

  updateTextPreview(state, side, textPreview);

  updateImagePreview(state, side, imagePreview, imageMap);

  // Show/hide clear button based on whether current side has text content
  const clearBtn = document.querySelector('.customization-clear-btn');
  if (clearBtn) {
    const hasText = state[side].lines.some(line => line.text.trim() !== "");
    const hasImage = !!state[side].selectedImage;
    const hasFont = !!state[side].selectedFont;
    clearBtn.style.display = (hasText || hasImage || hasFont) ? 'inline-block' : 'none';
  }
}

function updateTextPreview(state, side, textPreview) {
  const sideState = state[side];
  const pElements = textPreview.querySelectorAll("p[data-line-preview]");
  let filledLines = 0;

  pElements.forEach((p, index) => {
    const lineText = sideState.lines[index]?.text || "";
    const displayText = lineText.trim();
    if (displayText) {
      p.textContent = displayText;
      p.style.display = "block";
      filledLines++;
    } else {
      p.style.display = "none";
    }
    p.style.fontFamily = sideState.selectedFont ? `'${sideState.selectedFont}'` : "inherit";
  });

  // Update the preview header with line count
  const previewHeader =
    textPreview.querySelector(".preview-header") ||
    document.createElement("div");
  previewHeader.className = "preview-header";
  previewHeader.textContent = `Preview (${filledLines} line${filledLines !== 1 ? "s" : ""} with text)`;
  if (!textPreview.querySelector(".preview-header")) {
    textPreview.insertBefore(previewHeader, textPreview.firstChild);
  }
}

function updateImagePreview(state, side, imagePreview, imageMap) {
  const sideState = state[side];
  if (imagePreview) {
    imagePreview.src = imageMap[sideState.selectedImage] || "";
    imagePreview.style.display = sideState.selectedImage ? "block" : "none";
  }
}

function hasAnyCustomization(state) {
  const frontHasImage = !!state.front.selectedImage;
  const backHasImage = !!state.back.selectedImage;
  const frontHasText = state.front.lines.some((line) => line.text);
  const backHasText = state.back.lines.some((line) => line.text);

  return frontHasImage || backHasImage || frontHasText || backHasText;
}

function validateFontSelection(state) {
  if (!document.querySelector('.customization-font-swiper')) return null;
  const frontNeedsFont = state.front.type === "text" &&
    state.front.lines.some((l) => l.text.trim()) &&
    !state.front.selectedFont;
  const backNeedsFont = state.back.type === "text" &&
    state.back.lines.some((l) => l.text.trim()) &&
    !state.back.selectedFont;
  if (frontNeedsFont && backNeedsFont) return "Please select a font for your Front and Back text.";
  if (frontNeedsFont) return "Please select a font for your Front text.";
  if (backNeedsFont) return "Please select a font for your Back text.";
  return null;
}

function showFontError(msg) {
  const el = document.querySelector(".customization-font-error");
  if (el) { el.textContent = msg; el.style.display = "block"; }
}

function hideFontError() {
  const el = document.querySelector(".customization-font-error");
  if (el) { el.style.display = "none"; el.textContent = ""; }
}

let _confirmCallback = null;

function showConfirmModal(onConfirm) {
  const modal = document.getElementById("customization-confirm-modal");
  const checkbox = document.getElementById("customization-confirm-checkbox");
  const confirmBtn = document.getElementById("customization-confirm-btn");
  const cancelBtn = document.getElementById("customization-cancel-btn");
  if (!modal || !checkbox || !confirmBtn || !cancelBtn) { onConfirm(); return; }

  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  checkbox.checked = false;
  confirmBtn.disabled = true;
  modal.style.display = "flex";
  _confirmCallback = onConfirm;

  checkbox.onchange = () => { confirmBtn.disabled = !checkbox.checked; };
  confirmBtn.onclick = () => { const cb = _confirmCallback; hideConfirmModal(); cb?.(); };
  cancelBtn.onclick = () => hideConfirmModal();
  modal.querySelector(".customization-confirm-modal__backdrop").onclick = () => hideConfirmModal();
}

function hideConfirmModal() {
  const modal = document.getElementById("customization-confirm-modal");
  if (modal) modal.style.display = "none";
  _confirmCallback = null;
}

function setupBuyItNowInterceptor(productForm, state, force = false) {
  if (!productForm) return;

  // Prevent duplicate listeners
  if (productForm.dataset.buyNowInitialized && !force) return;
  productForm.dataset.buyNowInitialized = "true";

  const BUY_NOW_SELECTOR = '.button--buy-now, [id^="BuyItNow-"]';
  const DYNAMIC_BUTTON_SELECTOR = '.shopify-payment-button__button, [data-testid="ShopifyPayButton"], shopify-accelerated-checkout, shopify-buy-it-now-button';

  function runBuyNowCheckout() {
    var form = document.querySelector('product-form');
    if (!form) form = productForm;
    if (hasAnyCustomization(state)) {
      var fontError = validateFontSelection(state);
      if (fontError) { showFontError(fontError); return; }
      hideFontError();
      showConfirmModal(function () {
        addCustomizationProductsForCheckout(form, state).then(function () {
          window.location.href = '/checkout';
        });
      });
    } else {
      addCustomizationProductsForCheckout(form, state).then(function () {
        window.location.href = '/checkout';
      }).catch(function (err) {
        console.error('Buy Now with customization:', err);
      });
    }
  }

  // Use a single capture listener on product-form so we intercept even after the Buy Buttons
  // block is replaced by product-info.js (variant change). New buttons are still inside product-form.
  productForm.addEventListener('click', function (e) {
    var buyNowBtn = e.target.closest(BUY_NOW_SELECTOR);
    var dynamicBtn = e.target.closest(DYNAMIC_BUTTON_SELECTOR);
    if (!buyNowBtn && !dynamicBtn) return;

    e.preventDefault();
    e.stopPropagation();
    runBuyNowCheckout();
  }, true);
}

async function addCustomizationProductsForCheckout(form, state) {
  const variantIdInput = form.querySelector('input[name="id"]');
  const quantityInput = form.querySelector('input[name="quantity"]');

  const variantId = variantIdInput ? parseInt(variantIdInput.value) : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  if (!variantId) {
    console.error("Could not find variant ID in form");
    return;
  }

  const properties = {};

  if (state.front.selectedFont)
    properties["Front Font"] = state.front.selectedFont;
  state.front.lines.forEach((line, index) => {
    if (line.text) properties[`Front Line ${index + 1}`] = line.text;
  });
  if (state.front.selectedImage)
    properties["Front Image"] = state.front.selectedImage;

  if (state.back.selectedFont)
    properties["Back Font"] = state.back.selectedFont;
  state.back.lines.forEach((line, index) => {
    if (line.text) properties[`Back Line ${index + 1}`] = line.text;
  });
  if (state.back.selectedImage)
    properties["Back Image"] = state.back.selectedImage;

  if (hasAnyCustomization(state)) {
    properties["Important Note"] = "Engraved and personalized items are not able to be modified, canceled or returned once the order has been placed.";
  }

  const baseItem = {
    id: variantId,
    quantity: quantity,
    properties: properties,
  };

  try {
    const baseResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [baseItem] }),
    });
    const baseData = await baseResponse.json();

    const hasProps = Object.keys(properties).length > 0;
    const baseItemKey = baseData.items.find(item => {
      if (item.variant_id !== variantId) return false;
      if (!hasProps) return true;
      return JSON.stringify(item.properties || {}) === JSON.stringify(properties);
    })?.key;

    if (!baseItemKey) {
      if (hasProps) console.error("Could not find base item key");
      return baseData;
    }

    const frontHasImage = !!state.front.selectedImage;
    const backHasImage = !!state.back.selectedImage;
    const frontHasText = state.front.lines.some((line) => line.text);
    const backHasText = state.back.lines.some((line) => line.text);

    const customizationItems = [];

    if (window.customizationSettings.image_product) {
      if (frontHasImage) {
        customizationItems.push({
          id: window.customizationSettings.image_product.id,
          parent_line_key: baseItemKey,
          quantity,
          properties: { '_is_customization': 'true', '_side': 'front', '_parent_key': baseItemKey },
        });
      }
      if (backHasImage) {
        customizationItems.push({
          id: window.customizationSettings.image_product.id,
          quantity,
          parent_line_key: baseItemKey,
          properties: { '_is_customization': 'true', '_side': 'back', '_parent_key': baseItemKey },
        });
      }
    }

    if (window.customizationSettings.text_product) {
      if (frontHasText) {
        customizationItems.push({
          id: window.customizationSettings.text_product.id,
          quantity,
          parent_line_key: baseItemKey,
          properties: { '_is_customization': 'true', '_side': 'front', '_parent_key': baseItemKey },
        });
      }
      if (backHasText) {
        customizationItems.push({
          id: window.customizationSettings.text_product.id,
          quantity,
          parent_line_key: baseItemKey,
          properties: { '_is_customization': 'true', '_side': 'back', '_parent_key': baseItemKey },
        });
      }
    }

    if (customizationItems.length > 0) {
      // Add customization items
      const finalResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: customizationItems }),
      });
      return await finalResponse.json();
    } else {
      // No customizations, just return the base data
      return baseData;
    }
  } catch (error) {
    console.error("Error adding customization products for checkout:", error);
    throw error;
  }
}

function addToCartWithCustomization(state) {
  const form = document.querySelector("product-form");
  if (!form) return Promise.resolve();

  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = form.querySelector('input[name="quantity"]').value || 1;

  const properties = {};

  if (state.front.selectedFont)
    properties["Front Font"] = state.front.selectedFont;
  state.front.lines.forEach((line, index) => {
    if (line.text) properties[`Front Line ${index + 1}`] = line.text;
  });
  if (state.front.selectedImage)
    properties["Front Image"] = state.front.selectedImage;

  if (state.back.selectedFont)
    properties["Back Font"] = state.back.selectedFont;
  state.back.lines.forEach((line, index) => {
    if (line.text) properties[`Back Line ${index + 1}`] = line.text;
  });
  if (state.back.selectedImage)
    properties["Back Image"] = state.back.selectedImage;

  if (hasAnyCustomization(state)) {
    properties["Important Note"] = "Engraved and personalized items are not able to be modified, canceled or returned once the order has been placed.";
  }

  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = cartDrawer && cartDrawer.getSectionsToRender ? 
    cartDrawer.getSectionsToRender().map((section) => section.id) : [];

  // First add the base product
  const baseItem = {
    id: parseInt(variantId),
    quantity: parseInt(quantity),
    properties: properties,
  };

  return fetch("/cart/add.js", {
    ...fetchConfig(),
    body: JSON.stringify({ 
      items: [baseItem],
      sections: sectionsToRender,
      sections_url: window.location.pathname
    }),
  })
    .then((response) => response.json())
    .then(async (baseData) => {
      // Find the key of the base product we just added
      const hasProps = Object.keys(properties).length > 0;
      const baseItemKey = baseData.items.find(item => {
        if (item.variant_id !== parseInt(variantId)) return false;
        if (!hasProps) return true;
        return JSON.stringify(item.properties || {}) === JSON.stringify(properties);
      })?.key;

      if (!baseItemKey) {
        if (hasProps) console.error("Could not find base item key");
        return baseData;
      }

      const frontHasImage = !!state.front.selectedImage;
      const backHasImage = !!state.back.selectedImage;
      const frontHasText = state.front.lines.some((line) => line.text);
      const backHasText = state.back.lines.some((line) => line.text);

      const customizationItems = [];

      if (window.customizationSettings.image_product) {
        if (frontHasImage) {
          customizationItems.push({
            id: window.customizationSettings.image_product.id,
            quantity,
            parent_line_key: baseItemKey,
            properties: { '_is_customization': 'true', '_side': 'front', '_parent_key': baseItemKey },
          });
        }
        if (backHasImage) {
          customizationItems.push({
            id: window.customizationSettings.image_product.id,
            quantity,
            parent_line_key: baseItemKey,
            properties: { '_is_customization': 'true', '_side': 'back', '_parent_key': baseItemKey },
          });
        }
      }

      if (window.customizationSettings.text_product) {
        if (frontHasText) {
          customizationItems.push({
            id: window.customizationSettings.text_product.id,
            quantity,
            parent_line_key: baseItemKey,
            properties: { '_is_customization': 'true', '_side': 'front', '_parent_key': baseItemKey },
          });
        }
        if (backHasText) {
          customizationItems.push({
            id: window.customizationSettings.text_product.id,
            quantity,
            parent_line_key: baseItemKey,
            properties: { '_is_customization': 'true', '_side': 'back', '_parent_key': baseItemKey },
          });
        }
      }

      if (customizationItems.length > 0) {
        return fetch("/cart/add.js", {
          ...fetchConfig(),
          body: JSON.stringify({ 
            items: customizationItems,
            sections: sectionsToRender,
            sections_url: window.location.pathname
          }),
        })
          .then((response) => response.json())
          .then(async (finalData) => {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              cartData: finalData,
            });

            if (cartDrawer && cartDrawer.renderContents) {
              cartDrawer.classList.toggle('is-empty', finalData.item_count === 0);
              cartDrawer.renderContents(finalData);
            }

            queueMicrotask(() => {
              if (customizationElements) {
                hardReset(customizationElements);
              }
            });

            window.scrollTo({ top: 0, behavior: 'smooth' });

            return finalData;
          });
      } else {
        // No customizations, just return the base data
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          cartData: baseData,
        });

        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.classList.toggle('is-empty', baseData.item_count === 0);
          cartDrawer.renderContents(baseData);
        }

        queueMicrotask(() => {
          if (customizationElements) {
            hardReset(customizationElements);
          }
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });

        return baseData;
      }
    })
    .catch((error) => console.error("Error adding to cart", error));
}

async function loadCustomizationImages() {
  const STOREFRONT_TOKEN = "f03bcbe287205c23fd45fdd8609eefb1";
  const query = `{
    metaobjects(type: "customization_settings", first: 1) {
      nodes {
        fields {
          key
          references(first: 250) {
            nodes {
              ... on MediaImage {
                image {
                  originalUrl: url
                  thumbnailUrl: url(transform: { maxWidth: 100 })
                  altText
                }
              }
            }
          }
        }
      }
    }
  }`;

  try {
    const res = await fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query }),
    });
    const json = await res.json();
    const fields = json?.data?.metaobjects?.nodes?.[0]?.fields || [];
    const imagesField = fields.find(f => f.key === "images");
    const images = imagesField?.references?.nodes || [];

    if (!images.length) return;

    ["front", "back"].forEach(side => {
      const wrapper = document.querySelector(
        side === "front"
          ? ".customization-front-image-swiper .swiper-wrapper"
          : ".customization-back-image-swiper .swiper-wrapper"
      );
      if (!wrapper) return;

      images.forEach((node, i) => {
        const originalUrl = node?.image?.originalUrl;
        const thumbnailUrl = node?.image?.thumbnailUrl;
        const alt = node?.image?.altText || "";
        if (!originalUrl) return;

        const filename = originalUrl.split("/").pop().split("?")[0].replace(/_/g, " ");
        const index = i + 1;
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.innerHTML = `
          <input type="radio" id="${side}-image-${index}" name="properties[${side === "front" ? "Front" : "Back"} Image]" value="${filename}">
          <label for="${side}-image-${index}">
            <img src="${thumbnailUrl || originalUrl}" alt="${alt || filename}" width="80" height="auto" loading="lazy">
          </label>`;
        wrapper.appendChild(slide);
      });

      // Reinit swiper after populating
      const swiperEl = wrapper.closest(".swiper");
      if (swiperEl?.swiper) swiperEl.swiper.update();
    });

    // Update imageMap with all loaded images
    images.forEach(node => {
      const originalUrl = node?.image?.originalUrl;
      if (!originalUrl) return;
      const filename = originalUrl.split("/").pop().split("?")[0].replace(/_/g, " ");
      const key = filename.replace(/\.[^/.]+$/, "");
      imageMap[key] = originalUrl;
    });
  } catch (e) {
    console.error("Failed to load customization images", e);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", () => { initializeCustomizer(); loadCustomizationImages(); });
} else {
  initializeCustomizer();
  loadCustomizationImages();
}

// Global delegated listener for the "Customize this product" toggle button
// This is the most resilient way to handle event listeners across page navigations/cache
document.addEventListener("click", (e) => {
  const buttonWrapper = e.target.closest(".product_customization__button-wrapper");
  if (buttonWrapper) {
    const customizer = buttonWrapper.closest(".product_customization");
    const customizationOptions = customizer ? customizer.querySelector(".customization-options") : null;
    if (customizationOptions) {
      e.preventDefault();
      e.stopPropagation();
      const currentDisplay = window.getComputedStyle(customizationOptions).display;
      const newDisplay = currentDisplay === "none" ? "block" : "none";
      customizationOptions.style.display = newDisplay;
      customizerIsOpen = newDisplay === "block";
    }
  }
});

// Handle back/forward navigation (bfcache)
window.addEventListener("pageshow", (event) => {
  if (event.persisted || !window.customizerInitialized) {
    const customizer = document.querySelector(".product_customization");
    if (customizer) {
      // Force re-init after a small delay to ensure DOM is ready
      setTimeout(() => {
        window.customizerInitialized = false;
        initializeCustomizer(true);
      }, 50);
    }
  }
});

// Prevent half-restored state on page unload
window.addEventListener("beforeunload", () => {
  window.customizerInitialized = false;
});
